import { Box, Button, useDialog, useToast } from '@aicon-dev/caas-ui';
import { useMutation } from '@tanstack/react-query';

import { Divider } from '~/components/ui/Divider';
import { useCatch } from '~/libs/hooks/useCatch';
import { useAuthContext } from '~/modules/auth/context/AuthProvider';
import { disconnectOAuth } from '~/modules/auth/libs/apis';
import { IconApple, IconGoogle, IconKakao, IconNaver } from '~/modules/auth/libs/icons';

export const UserFormOAuth = () => {
  const { userInfo, logout } = useAuthContext();
  const dialog = useDialog();
  const toast = useToast();
  const { catchError } = useCatch();

  const { mutateAsync } = useMutation({
    mutationFn: async () => {
      await disconnectOAuth(userInfo?._id ?? '');
    },

    onSuccess() {
      toast.normal('SNS 연결이 해제되었습니다.');
      logout();
    },
    onError(error) {
      catchError(error);
    },
  });

  const renderIcon = () => {
    if (userInfo?.oAuth?.kakao) {
      return <IconKakao size={24} />;
    }
    if (userInfo?.oAuth?.naver) {
      return <IconNaver size={24} />;
    }
    if (userInfo?.oAuth?.google) {
      return <IconGoogle size={24} />;
    }
    if (userInfo?.oAuth?.apple) {
      return <IconApple size={24} />;
    }
  };

  return (
    <>
      <Box display="flex" justify="space-between" align="center" py="24" px="16">
        <Box display="flex" align="center" gap="8">
          {renderIcon()}
          <Box fw={500}>SNS 연결</Box>
        </Box>
        <Button
          type="button"
          color="primary"
          variant="filled"
          size="small"
          onClick={() => {
            dialog.danger({
              title: 'SNS 연결을 해제하시겠습니까? 연결이 해제되면 자동으로 로그아웃됩니다.',
              onOk: mutateAsync,
            });
          }}
        >
          해제
        </Button>
      </Box>
      <Divider size="large" />
    </>
  );
};
